import BCComponent from "./bc_component";
import {bindActionCreators} from "redux";
import {getBonusTasks, submitBonusTask} from "game/app/actions/bonus-tasks-actions";
import connect from "react-redux/es/connect/connect";
import React from "react";

class Oblast4 extends BCComponent {

    render() {
        return (
            <div>
                <h1>PSANÉ SLOVO, KVÍZ</h1>
                <div className='separate-bottom'>
                    <p>Pokud chcete proniknout hlouběji do nějakého tématu nebo znát názor odborníků na určité téma, dobrý zdrojem inspirace a informací jsou odborné články. Ty je nejlepší hledat na odborných webových portálech nebo v médiích. Rozsáhlejší texty pak najdete v knížkách a dalších publikacích.</p>
                    <p>Četba knih je od vynálezu knihtisku základním zdrojem informací. Při četbě navíc rozvíjíme naše myšlení a fantazii a posilujeme vyjadřovací schopnosti. Knihy mohou být různého typu - některé jsou jen pro zábavu, některé slouží pro osobní rozvoj či vzdělávání. Pro tyto účely je nejlepší vyhledávat knihy odborné.</p>
                    <p>Četbou si rozšiřujeme znalosti, slovní zásobu a schopnost porozumění, při pokusech o psaní vlastních úvah, článků, básniček, povídek či knížek se navíc učíme strukturovat naše myšlenky.</p>
                </div>

                { this.showTask("zs_slovo_1") }
                { this.showTask("zs_slovo_2") }
            </div>
        );
    }
}

function mapStateToProps(state,ownProps) {
    return {
        bonusTasks: state.bonusTasks,
        gameInstance: state.gameInstance
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
        getBonusTasks: getBonusTasks,
        submitBonusTask: submitBonusTask
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(Oblast4);
